export const NOTES = ["C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#", "B"];
export const FLATS = { "C#": "Db", "D#": "Eb", "F#": "Gb", "G#": "Ab", "A#": "Bb" };

export const TYPES = [
  { id: "maj", label: "Major", suffix: "", iv: [0, 4, 7] },
  { id: "min", label: "Minor", suffix: "m", iv: [0, 3, 7] },
  { id: "7", label: "Dominant 7", suffix: "7", iv: [0, 4, 7, 10] },
  { id: "maj7", label: "Major 7", suffix: "maj7", iv: [0, 4, 7, 11] },
  { id: "m7", label: "Minor 7", suffix: "m7", iv: [0, 3, 7, 10] },
  { id: "sus2", label: "Sus 2", suffix: "sus2", iv: [0, 2, 7] },
  { id: "sus4", label: "Sus 4", suffix: "sus4", iv: [0, 5, 7] },
  { id: "6", label: "Major 6", suffix: "6", iv: [0, 4, 7, 9] },
  { id: "m6", label: "Minor 6", suffix: "m6", iv: [0, 3, 7, 9] },
  { id: "9", label: "Dominant 9", suffix: "9", iv: [0, 4, 7, 10, 14] },
  { id: "dim", label: "Diminished", suffix: "dim", iv: [0, 3, 6] },
  { id: "dim7", label: "Diminished 7", suffix: "dim7", iv: [0, 3, 6, 9] },
  { id: "aug", label: "Augmented", suffix: "aug", iv: [0, 4, 8] },
];

const X = null;
// Movable shapes, frets relative to the root fret (low E → high e).
const E_SHAPE = {
  maj: [0, 2, 2, 1, 0, 0], min: [0, 2, 2, 0, 0, 0], 7: [0, 2, 0, 1, 0, 0], maj7: [0, X, 1, 1, 0, X],
  m7: [0, 2, 0, 0, 0, 0], sus2: [0, 2, 4, 4, 0, 0], sus4: [0, 2, 2, 2, 0, 0], 6: [0, 2, 2, 1, 2, 0],
  m6: [0, 2, 2, 0, 2, 0], 9: [0, 2, 0, 1, 0, 2], dim: [0, 1, 2, 0, X, X], dim7: [0, 1, 2, 0, 2, 0], aug: [0, 3, 2, 1, 1, 0],
};
const A_SHAPE = {
  maj: [X, 0, 2, 2, 2, 0], min: [X, 0, 2, 2, 1, 0], 7: [X, 0, 2, 0, 2, 0], maj7: [X, 0, 2, 1, 2, 0],
  m7: [X, 0, 2, 0, 1, 0], sus2: [X, 0, 2, 2, 0, 0], sus4: [X, 0, 2, 2, 3, 0], 6: [X, 0, 2, 2, 2, 2],
  m6: [X, 0, 2, 2, 1, 2], 9: [X, 0, 2, 4, 2, 3], dim: [X, 0, 1, 2, 1, X], dim7: [X, 0, 1, 2, 1, 2], aug: [X, 0, 3, 2, 2, 1],
};
// Classic open shapes (absolute frets).
const OPEN = {
  "C:maj": [X, 3, 2, 0, 1, 0], "G:maj": [3, 2, 0, 0, 0, 3], "D:maj": [X, X, 0, 2, 3, 2], "D:min": [X, X, 0, 2, 3, 1],
  "D:7": [X, X, 0, 2, 1, 2], "C:7": [X, 3, 2, 3, 1, 0], "G:7": [3, 2, 0, 0, 0, 1], "C:maj7": [X, 3, 2, 0, 0, 0],
  "D:maj7": [X, X, 0, 2, 2, 2], "F:maj7": [X, X, 3, 2, 1, 0], "D:sus4": [X, X, 0, 2, 3, 3], "D:sus2": [X, X, 0, 2, 3, 0],
  "D:m7": [X, X, 0, 2, 1, 1], "C:sus2": [X, 3, 0, 0, 1, 3], "C:sus4": [X, 3, 3, 0, 1, 1],
};
export const STRING_MIDI = [40, 45, 50, 55, 59, 64];

export function guitarShape(root, type) {
  const open = OPEN[`${root}:${type}`];
  if (open) return open;
  const ri = NOTES.indexOf(root);
  const rE = (ri - 4 + 12) % 12;
  const rA = (ri - 9 + 12) % 12;
  const useE = rE <= rA;
  const r = useE ? rE : rA;
  return (useE ? E_SHAPE : A_SHAPE)[type].map((o) => (o === X ? X : o + r));
}

export function chordName(root, type) {
  return `${root}${TYPES.find((t) => t.id === type).suffix}`;
}

export function pianoMidis(root, type) {
  const ri = NOTES.indexOf(root);
  return TYPES.find((t) => t.id === type).iv.map((i) => {
    const m = 60 + ri + i;
    return m > 84 ? m - 12 : m;
  });
}

export function chordNotes(root, type) {
  const ri = NOTES.indexOf(root);
  return TYPES.find((t) => t.id === type).iv.map((i) => NOTES[(ri + i) % 12]);
}

export const guitarMidis = (frets) => frets.map((f, i) => (f === X ? null : STRING_MIDI[i] + f)).filter((m) => m !== null);
